import { Injectable } from '@angular/core';

@Injectable()

export class gigyaInfo {
    public error: boolean;
    public errorCode: number;
    public errorMessage: string;
    public regToken: string;
    public gigyaUid: string;
    public accNumber: string;
    public accountId: number;
    public accountName: string;
    public userId: number;
    public firstName: string;
    public lastName: string;
    public hasLoggedIn: boolean;
    public userMail: string;
    public address: string;
    public companyName: string;
    public mobileNumber: string;
    public postalCode: string;
    public city: string;
    public countryId: number;
    public subscribeStatus: boolean;
    public solidoNo: string;
    public accessIdentifier: string;
    public counts: number;
    public languageCode: string;
    public countryCode: string;
    public vatNumber: string;
    public modBought: boolean;
    public ptokenBought: boolean;
    public tokenBal: number;
    public emailEdit: boolean;
    public userIpn: string;
    public parentId: number;
    public ticketBal?: number;
    public gateWayModuleBought: boolean;
    public reprogModuleBought: boolean;
    public autoConfigModuleBought: boolean;
    public invioModuleBought: boolean;
    public adtModuleBought: boolean;
    public globalModuleBought: boolean;
    public personalDataAccess: boolean;
    public deliveryFirstName: string;
    public deliveryLastName: string;
    public deliveryAddress: string;
    public deliveryCompanyName: string;
    public deliveryMobileNumber: string;
    public deliveryPostalCode: string;
    public deliveryCity: string;
    public deliveryCountryId: number;
    public siren: number;
    public siret: any;
    public routingCode: string;
    public suffix: string;
    public eInvoice: string;
    public registerNumber: string;
    public message?: string;
}